import { APPLET_ACCESS_DENIAL_REASON } from '@cartwhl/common/appletPolicy';
import Text from '@cartwhl/ui/base/Text';
import Button from '@cartwhl/ui/input/Button';

import type { AppletAccessDeniedProps } from './AppletGuard';

export default function DefaultAppletAccessDenied({
  reason,
  message,
  signUpUrl,
}: AppletAccessDeniedProps) {
  const resolvedMessage =
    reason === APPLET_ACCESS_DENIAL_REASON.noApiKey ? (
      <>
        You don&apos;t have an API key. Please{' '}
        <a
          href="mailto:support@getcartwheel.com"
          target="_blank"
          rel="noreferrer"
          className="text-blue underline"
        >
          contact support
        </a>{' '}
        to get access.
      </>
    ) : (
      message
    );

  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4">
      <Text
        variant="studio/body/medium/md"
        className="text-secondary text-center"
      >
        {resolvedMessage}
      </Text>
      {reason === APPLET_ACCESS_DENIAL_REASON.anonymous && (
        <a href={signUpUrl}>
          <Button variant="secondary">Sign up</Button>
        </a>
      )}
    </div>
  );
}
